
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Menu, X, LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { MobileMenu } from './MobileMenu';
import { useAuth } from '@/hooks/useAuth';

export const PublicNavbar: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { user, signOut } = useAuth();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const handleSignOut = async () => {
    await signOut();
  };

  return (
    <>
      <nav className="fixed top-0 w-full bg-white/95 backdrop-blur-sm border-b border-neutral-200 z-50 shadow-brand">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <div className="flex items-center">
              <Link 
                to="/" 
                className="text-h4 font-bold flex items-center gap-2 hover:opacity-80 transition-opacity focus-visible-ring"
                onClick={closeMobileMenu}
              >
                <Sparkles className="w-8 h-8 text-brand-primary" />
                <span className="brand-gradient-text">CoPlanner</span>
              </Link>
            </div>
            
            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">              
              <Link 
                to="/#caracteristicas" 
                className="text-body-md font-medium text-black hover:text-brand-primary-hover transition-colors focus-visible-ring px-3 py-2 rounded-md"
              >
                Inicio
              </Link>
              <Link 
                to="/precios" 
                className="text-body-md font-medium text-black hover:text-brand-primary-hover transition-colors focus-visible-ring px-3 py-2 rounded-md"
              >
                Precios
              </Link>

              <Link 
                to="/acerca-de" 
                className="text-body-md font-medium text-black hover:text-brand-primary-hover transition-colors focus-visible-ring px-3 py-2 rounded-md"
              >
                Acerca de
              </Link>
            </div>

            {/* Desktop Auth Buttons */}
            <div className="hidden md:flex items-center space-x-4">
              {user ? (
                <>
                  <Link 
                    to="/app/dashboard" 
                    className="text-body-md font-medium text-black hover:text-brand-primary-hover transition-colors focus-visible-ring px-4 py-2 rounded-md"
                  >
                    Mi Dashboard
                  </Link>
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={handleSignOut}
                    className="text-body-md font-medium text-black hover:text-brand-primary-hover transition-colors focus-visible-ring"
                  >
                    <LogOut className="w-4 h-4 mr-2" />
                    Cerrar sesión
                  </Button>
                </>
              ) : (
                <>
                  <Link 
                    to="/login" 
                    className="text-body-md font-medium text-black hover:text-brand-primary-hover transition-colors focus-visible-ring px-4 py-2 rounded-md"
                  >
                    Iniciar sesión
                  </Link>
                  <Link to="/signup">
                    <Button className="btn-primary shadow-sm">
                      Empieza gratis
                    </Button>
                  </Link>
                </>
              )}
            </div>

            {/* Mobile Menu Button */}
            <div className="md:hidden">
              <Button
                variant="ghost"
                size="icon"
                onClick={toggleMobileMenu}
                className="text-brand-primary hover:bg-neutral-100 focus-visible-ring"
                aria-label={isMobileMenuOpen ? "Cerrar menú" : "Abrir menú"}
              >
                {isMobileMenuOpen ? (
                  <X className="w-6 h-6" />
                ) : (
                  <Menu className="w-6 h-6" />
                )}
              </Button>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Component */}
      <MobileMenu 
        isOpen={isMobileMenuOpen} 
        onClose={closeMobileMenu} 
      />
    </>
  );
};
